/**
 * BONI brand palette shared by CSS/Tailwind (`boniYellowPrimary`) and Three.js.
 * Keep string/hex values in sync with `tailwind.config.js`.
 */
export const BONI_YELLOW_PRIMARY = "#ffea74";
export const BONI_YELLOW_PRIMARY_HEX = 0xffea74;

/** Slightly darker yellow used for active UI feedback. */
export const BONI_YELLOW_PRIMARY_ACTIVE = "#f4dd5a";
export const BONI_YELLOW_PRIMARY_ACTIVE_HEX = 0xf4dd5a;

/**
 * Canvas selection / hover / handle accent.
 * Kept blue for now (UI chrome uses yellow separately).
 */
export const CANVAS_ACCENT_COLOR = "blue";
/** Numeric THREE.js equivalent of `CANVAS_ACCENT_COLOR` ("blue"). */
export const CANVAS_ACCENT_COLOR_HEX = 0x0000ff;
/** @deprecated Prefer CANVAS_ACCENT_COLOR — alias kept for existing call sites. */
export const CANVAS_HOVER_COLOR = CANVAS_ACCENT_COLOR;

/**
 * Shared checkbox classes: yellow fill with black checkmark and border for contrast.
 * Styled by `.boni-checkbox` in `index.css`.
 */
export const BONI_CHECKBOX_CLASSNAME =
  "boni-checkbox h-5 w-5 shrink-0 cursor-pointer rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-blackplum/30";

/**
 * Resolve canvas accent: selected or hover → blue, else fallback.
 */
export function canvasAccentColor(
  selected: boolean | undefined,
  hovered: boolean | undefined,
  fallback: string | number,
): string | number {
  if (selected || hovered) return CANVAS_ACCENT_COLOR;
  return fallback;
}

/**
 * Resolve handle fill: actively dragging or hover → blue, else white.
 */
export function canvasHandleFillColor(
  active: boolean | undefined,
  hovered: boolean | undefined,
): string {
  if (active || hovered) return CANVAS_ACCENT_COLOR;
  return "white";
}
